import { useState } from 'react';
import { loginWithGoogle } from '../services/api';
import { useAuth } from './AuthContext';

export function useAuthGoogle() {
  const [error, setError] = useState<string | null>(null);
  const { login } = useAuth();

  const handleGoogleLogin = async (credential: string): Promise<boolean> => {
    try {
      const response = await loginWithGoogle(credential);
      await login(response.token);
      return true; 
    } catch (err: any) {
      setError(err.message);
      return false; 
    }
  };

  return { handleGoogleLogin, error };
}
